'use client';

import { c as _c } from "react/compiler-runtime";
import { Kanban } from 'lucide-react';
import { IntegrationRow } from './IntegrationList';
type Props = {
  enabled: boolean;
  onToggle: () => void;
};

// Board cards are work items, not social posts, so the account's auto
// cross-post platforms skip them unless this is on. Picking platforms by hand
// in the composer still cross-posts a card either way.
const AutoCrossPostBoardCardsToggle = t0 => {
  const $ = _c(11);
  const {
    enabled,
    onToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Kanban size={18} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = enabled ? "Cards you create on a board auto-post too" : "Cards you create on a board stay off auto-post; picking networks by hand still sends them";
  const t3 = `relative inline-flex h-5 w-9 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none ${enabled ? "bg-primary" : "bg-textSecondary/30"}`;
  const t4 = `pointer-events-none inline-block size-4 rounded-full bg-white shadow transition-transform duration-200 ${enabled ? "translate-x-4" : "translate-x-0"}`;
  let t5;
  if ($[1] !== t4) {
    t5 = <span className={t4} />;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== enabled || $[4] !== onToggle || $[5] !== t3 || $[6] !== t5) {
    t6 = <label className="mr-2 flex cursor-pointer items-center gap-2 text-xs text-textSecondary">Auto-post<button type="button" role="switch" aria-checked={enabled} aria-label="Auto cross-post board cards" onClick={onToggle} className={t3}>{t5}</button></label>;
    $[3] = enabled;
    $[4] = onToggle;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t6) {
    t7 = <IntegrationRow icon={t1} name="Board cards" status={t2} actions={t6} />;
    $[8] = t2;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default AutoCrossPostBoardCardsToggle;